import { render, staticRenderFns } from "./FinancialDetails.vue?vue&type=template&id=5cb1467f&"
import script from "./FinancialDetails.vue?vue&type=script&lang=js&"
export * from "./FinancialDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports